<div class="row page-header">
    <div class="col-12">
        <h1>Bid Outlook <small>View and manage upcoming bids, opportunities, prequalifications, and proposals</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="onTabChange()" style="margin-bottom: 10px">
                @if (canViewOutlooks) {
                    <li [ngbNavItem]="1"><a ngbNavLink>Outlooks ({{ outlookCount }})</a></li>
                }
                @if (canViewOutlooks) {
                    <li [ngbNavItem]="2"><a ngbNavLink>Opportunities ({{ opportunityCount }})</a></li>
                }
                @if (canViewPrequalification) {
                    <li [ngbNavItem]="3"><a ngbNavLink>Prequalification</a></li>
                }
                @if (canViewProposalBids) {
                    <li [ngbNavItem]="4"><a ngbNavLink>Proposal Bids</a></li>
                }
            </ul>
            <div [hidden]="active !== 1 && active !== 2">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <button type="button" class="btn btn-sm btn-secondary" (click)="complete()" [disabled]="!grid.hasItemSelected">
                            <fa-icon [icon]="faCheck"></fa-icon> Complete
                        </button>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Bid Outlook'"></grid-export>
                        @if (loadingFadeGain) {
                            <span style="line-height: 30px"
                                ><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon> Loading Fade/Gain Data</span
                            >
                        }
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            style="margin-left: auto"
                            (click)="showAll = !showAll; filterItems()"
                        >
                            {{ showAll ? 'Hide Complete' : 'Show Complete' }}
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemFormatter]="mainGridItemFormatter"
                        (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="1"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'bidDescription'" [width]="275"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Risk'"
                            [binding]="'risk'"
                            [width]="70"
                            [dataMap]="riskMap"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Need Plans'"
                            [binding]="'needPlans'"
                            [width]="75"
                            [format]="'D'"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Bid Bond'" [binding]="'bidBond'" [width]="60" [visible]="isOutlooksTab"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'PQ'" [binding]="'pq'" [width]="55"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'SD'" [binding]="'sd'" [width]="55"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'CM GC'" [binding]="'cmGc'" [width]="60"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Plan Source'" [binding]="'planSource'" [width]="150" [visible]="isOutlooksTab"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Delivery Type'"
                            [binding]="'bidDelivery'"
                            [width]="150"
                            [dataMap]="deliveryTypeMap"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>

                        <!-- <wj-flex-grid-column
                            [header]="'Plan Received On'"
                            [binding]="'planReceivedDate'"
                            [width]="125"
                            [editor]="inputDate"
                            [isRequired]="false"
                            [visible]="false"
                        ></wj-flex-grid-column> -->

                        <wj-flex-grid-column [header]="'Public Opening'" [binding]="'publicOpening'" [width]="110" [visible]="isOutlooksTab"></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Owner'"
                            [binding]="'ownerId'"
                            [width]="180"
                            [dataMap]="ownersMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Completion Date'"
                            [binding]="'completionDate'"
                            [width]="125"
                            [editor]="inputDate"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Engineer Estimate'"
                            [binding]="'bidRangeId'"
                            [width]="155"
                            [dataMap]="rangeMap"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column [header]="'Ready For Review'" [binding]="'readyForReview'" [width]="110" [visible]="isOutlooksTab"></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Estimator Time Off'"
                            [binding]="'estimatorTimeOffNames'"
                            [width]="180"
                            [isReadOnly]="true"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Estimator Name'"
                            [binding]="'estimatorHrRef'"
                            [width]="130"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Reviewer'"
                            [binding]="'reviewerHrRef'"
                            [width]="150"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Date'"
                            [binding]="'bidDate'"
                            [width]="190"
                            [format]="'g'"
                            [editor]="inputDateTime"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Anticipated Bid Date'"
                            [binding]="'anticipatedBidDate'"
                            [format]="'MMM yyyy'"
                            [width]="120"
                            [editor]="inputDateMonth"
                            [isRequired]="false"
                            [visible]="isOpportunitiesTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Pre Bid Date'"
                            [binding]="'preBidDate'"
                            [width]="190"
                            [format]="'g'"
                            [editor]="inputDateTime"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Pre-Bid Competitors'" [binding]="'competitorIds'" [width]="150" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <a
                                    href="javascript:void(0)"
                                    (click)="openPreBidCompetitorsModal(item)"
                                    [class.text-muted]="!item.competitorIds || item.competitorIds.length === 0"
                                    style="cursor: pointer; text-decoration: underline"
                                >
                                    {{ getPreBidCompetitorsCount(item) }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>

                        <wj-flex-grid-column [header]="'Man-datory'" [binding]="'mandatory'" [width]="80" [visible]="isOutlooksTab"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Person Going'"
                            [binding]="'personGoingHrRef'"
                            [width]="150"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                            [visible]="isOutlooksTab"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Type'"
                            [binding]="'bidTypeId'"
                            [width]="200"
                            [dataMap]="jobTypeMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Labor Fade/Gain'"
                            [binding]="'laborFadeGain'"
                            [width]="100"
                            [format]="'P'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Costs Fade/Gain'"
                            [binding]="'costFadeGain'"
                            [width]="100"
                            [format]="'p'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'D.B. Wages'" [binding]="'davisBaconWages'" [width]="80" [visible]="isOutlooksTab"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'AIS'" [binding]="'ais'" [width]="70" [visible]="isOutlooksTab"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'" [minWidth]="250"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <!--<grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>-->
                    <wj-input-date #inputDateMonth [selectionMode]="'Month'" [format]="'MMM yyyy'" [isRequired]="false"></wj-input-date>
                    <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                    <wj-input-date-time #inputDateTime [timeStep]="30" [isRequired]="false"></wj-input-date-time>
                </div>
            </div>
            </div>
            @if (prequalificationVisited) {
                <app-prequalifications [embedded]="true" [hidden]="active !== 3"></app-prequalifications>
            }
            @if (proposalBidsVisited) {
                <app-proposal-bids [embedded]="true" [hidden]="active !== 4"></app-proposal-bids>
            }
        </div>
    </div>
</div>
